import { createArrayFieldApi } from "./createArrayFieldApi/createArrayFieldApi.js";
import { createCommonApi } from "./createCommonApi/createCommonApi.js";
import { createCoreApi } from "./createCoreApi/createCoreApi.js";
import { createErrorsApi } from "./createErrorsApi/createErrorsApi.js";
import { createFieldApi } from "./createFieldApi/createFieldApi.js";
import { createFieldPrivateApi } from "./createFieldPrivateApi/createFieldPrivateApi.js";
import { createFieldSubscribeApi } from "./createFieldSubscribeApi/createFieldSubscribeApi.js";
import { createFormMetaSubscribeApi } from "./createFormMetaSubscribeApi/createFormMetaSubscribeApi.js";
import { createFormSubscribeApi } from "./createFormSubscribeApi/createFormSubscribeApi.js";
import { createLogger } from "./createLogger/createLogger.js";
import { createMutationApi } from "./createMutationApi/createMutationApi.js";
import { createRefreshFormStatus } from "./createRefreshFormStatus/createRefreshFormStatus.js";
import { createStore } from "./createStore/createStore.js";
import { createSubscriptionApi } from "./createSubscriptionApi/createSubscriptionApi.js";
import { createTransformApi } from "./createTransformApi/createTransformApi.js";
import { createValidationApi } from "./createValidationApi/createValidationApi.js";
import { validateCreateFormConfig } from "./validateCreateFormConfig.js";
function createForm(config) {
  validateCreateFormConfig(config);
  const { id: formId } = config;
  let debugMode = config?.debugMode ?? "silent";
  let log = createLogger(formId, debugMode);
  const getLogger = () => log;
  const store = createStore(config);
  const { fieldSubscribers, notifyFieldSubscribers, notifyFieldSubscriber } = createFieldSubscribeApi(
    store,
    getFormApi,
    getLogger
  );
  const { formSubscribers, notifyFormSubscribers } = createFormSubscribeApi(getFormApi, getLogger);
  const { formMetaSubscribers, notifyMetaSubscribers } = createFormMetaSubscribeApi(getFormApi, getLogger);
  const refreshFormStatus = createRefreshFormStatus(store, getLogger, getSubscribersApi);
  const { errorsByField, validatorsById, validatorIdByFunction, validatorsByField, validationApi } = createValidationApi(store, getFormApi, getLogger, getSubscribersApi, refreshFormStatus);
  const { fieldMutations, applyMutations, mutationApi } = createMutationApi(store);
  const { fieldTransforms, applyTransforms, transformApi } = createTransformApi(store);
  function getSubscribersApi() {
    return {
      notifyFieldSubscriber,
      notifyFieldSubscribers,
      notifyFormSubscribers,
      notifyMetaSubscribers
    };
  }
  const errorsApi = createErrorsApi(store, errorsByField, getLogger, getSubscribersApi, refreshFormStatus);
  const privateFieldApi = createFieldPrivateApi(store, getLogger, getSubscribersApi, refreshFormStatus);
  function getPrivateFieldApi() {
    return privateFieldApi;
  }
  const coreApi = createCoreApi(
    store,
    getFormApi,
    getLogger,
    getSubscribersApi,
    refreshFormStatus,
    applyMutations,
    applyTransforms,
    getPrivateFieldApi,
    errorsByField
  );
  const fieldApi = createFieldApi(
    store,
    getLogger,
    getSubscribersApi,
    refreshFormStatus,
    fieldMutations,
    fieldTransforms,
    validatorsById,
    validatorIdByFunction,
    validatorsByField,
    fieldSubscribers,
    errorsByField,
    getPrivateFieldApi
  );
  const arrayFieldApi = createArrayFieldApi(store, getFormApi, getLogger, getPrivateFieldApi);
  const subscriptionApi = createSubscriptionApi(fieldSubscribers, formSubscribers, formMetaSubscribers);
  const commonApi = createCommonApi(store, getLogger, getSubscribersApi);
  const api = {
    getFormId: () => formId,
    getDebugMode: () => debugMode,
    setDebugMode: (mode) => {
      debugMode = mode;
      log = createLogger(formId, debugMode);
    },
    ...errorsApi,
    ...coreApi,
    ...subscriptionApi,
    ...commonApi,
    ...mutationApi,
    ...transformApi,
    ...validationApi,
    ...fieldApi,
    ...arrayFieldApi
  };
  function getFormApi() {
    return api;
  }
  return {
    api: Object.freeze(api),
    store
  };
}
export {
  createForm
};
//# sourceMappingURL=createForm.js.map
